// Direct Stripe Payment Link — no backend required.
// Configure the "After payment" redirect in your Stripe Dashboard to:
// https://[your-domain]/download?session_id={CHECKOUT_SESSION_ID}
const STRIPE_PAYMENT_LINK = 'https://buy.stripe.com/bJeeVedtnfHDc2GeRV4AU00';

export const useCheckout = () => {
  const createCheckoutSession = (_product = 'fitness') => {
    window.location.href = STRIPE_PAYMENT_LINK;
  };

  return {
    createCheckoutSession,
    loading: false,
    error: null,
  };
};
